module.exports = __webpack_public_path__ + "assets-customer/images/accessories-category.png?cd6c86c4";